import { useContext } from "react"
import { UserContext } from "@context"
import { AdminDashboard, StaffSchedule } from "@components"
import { hasOrganiserRights } from "@helpers"

const Dashboard = () => {
    const { user } = useContext(UserContext)

    return (
        hasOrganiserRights(user) ? <AdminDashboard /> : <StaffSchedule />
    )
}

export default Dashboard
